var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19184 1.7017L17.0633 9.91879C17.7745 10.4255 18.1967 11.2448 18.1967 12.1179C18.1967 12.9913 17.7745 13.8105 17.0633 14.3171L6.18228 23.3049C5.2638 24.0343 4.02023 24.2037 2.94013 23.7465C1.86 23.2894 1.11587 22.2788 1 21.1115V3.90085C1.11172 2.72914 1.85669 1.71292 2.94051 1.25386C4.02433 0.79479 5.2726 0.966725 6.19184 1.7017Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunIcon);
export default __webpack_public_path__ + "static/media/runIcon.5a598c6ad4c8c89deaf1adeb07e9a745.svg";
export { ForwardRef as ReactComponent };